<template>
  <div class="ui two column centered stackable grid">
    <div class="column" style="text-align: center; margin-top: 5em;">
      <h2 class="ui image header">
        <div class="content">
          <i class="key icon"></i> Anmelden
        </div>
      </h2>
      <div class="ui segment">
        <p>Sie werden zur Anmeldung weitergeleitet...</p>
        <button class="ui fluid large primary button" v-on:click.prevent="hostedSignIn">
          <i class="external alternate icon"></i> Jetzt anmelden
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { Auth } from 'aws-amplify'

  export default {
    name: 'SignIn',
    data () {
      return {
          user: null,
          error: '',
          info: ''
      }
    },
    mounted () {
      // Automatically redirect to Hosted UI on mount
      this.hostedSignIn()
    },
    methods: {
      hostedSignIn: function() {
        Auth.federatedSignIn()
      },
      setError: function(err) {
          this.error = err.message || err
      }
    }
  }
</script>
